import { TemplateRef, ViewContainerRef } from '@angular/core';

export class pmdComponentRef<T> {
  templateRef: TemplateRef<T>;
  viewContainer: ViewContainerRef;
}
